import { supabase } from './supabase';
import { getCompanyInfo } from './knowledge-base';

// ============================================================================
// TYPES
// ============================================================================

export interface GbpPost {
  id: string;
  company_id: string;
  content: string;
  status: 'draft' | 'scheduled' | 'published' | 'failed';
  scheduled_at?: string;
  published_at?: string;
  post_id?: string;
  error_message?: string;
}

// ============================================================================
// GBP POSTS
// ============================================================================

export async function generateGbpPost(companyId: string): Promise<Partial<GbpPost>> {
  const companyRecords = await getCompanyInfo(companyId);
  const company = companyRecords[0];

  if (!company) {
    throw new Error(`No company info found for ${companyId}`);
  }

  const content = `This is an AI-generated post for ${company.company_name}.`;
  return {
    company_id: companyId,
    content,
    status: 'draft',
  };
}

export async function scheduleGbpPost(postId: string, scheduledAt: Date): Promise<void> {
  await supabase
    .from('gbp_posts')
    .update({ status: 'scheduled', scheduled_at: scheduledAt.toISOString() })
    .eq('id', postId);
}

export async function publishScheduledGbpPosts(): Promise<void> {
  const now = new Date().toISOString();
  const { data: posts } = await supabase
    .from('gbp_posts')
    .select('*')
    .eq('status', 'scheduled')
    .lte('scheduled_at', now);

  if (!posts) return;

  for (const post of posts) {
    try {
      // In production, this would call the Google API
      console.log(`Publishing post ${post.id} to GBP`);
      await supabase
        .from('gbp_posts')
        .update({ status: 'published', published_at: now, post_id: `mock_post_${post.id}` })
        .eq('id', post.id);
    } catch (error) {
      console.error(`Failed to publish post ${post.id}:`, error);
      await supabase
        .from('gbp_posts')
        .update({ status: 'failed', error_message: (error as Error).message })
        .eq('id', post.id);
    }
  }
}
